import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Produtos.css";
import { getProducts } from "../../services/api";

const Produtos = () => {
  const [flattenedProducts, setFlattenedProducts] = useState([]);

  useEffect(() => {
    getProducts()
      .then((data) => {
        // Para cada produto, se existir variantes, cria uma entrada para cada variante
        const flattened = [];
        data.forEach((produto) => {
          if (produto.variants && produto.variants.length > 0) {
            produto.variants.forEach((variant) => {
              flattened.push({
                ...produto,
                variant: variant,
              });
            });
          } else {
            flattened.push({ ...produto, variant: null });
          }
        });
        setFlattenedProducts(flattened);
      })
      .catch((error) => console.error("Erro ao carregar produtos:", error));
  }, []);

  return (
    <section className="produtos" id="produtos">
      <div className="produtos-container">
        <h2 className="produtos-title">
          PRODUTOS<span className="produtos-title-period">.</span>
        </h2>
        <hr className="produtos-divider" />
      </div>
      <div className="produtos-images-container">
        <div className="produtos-images">
          {flattenedProducts.map((item, index) => {
            const imageUrl = item.variant
              ? item.variant.imagem_url
              : item.imagem_url;
            const preco = item.variant ? item.variant.preco : item.preco;
            const estoque = item.variant ? item.variant.estoque : item.quantidade;
            const tamanho = item.variant ? item.variant.tamanho : null;

            return (
              <div key={index} className="produto-container">
                <div className="produto-image-container">
                  <img
                    src={imageUrl}
                    className="produto-image"
                    alt={item.titulo}
                  />
                </div>
                <div className="produto-detalhes">
                  <div className="title-container">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="circle" />
                      <span className="title">{item.titulo}</span>
                      {tamanho && (
                        <span
                          style={{
                            marginLeft: "10px",
                            fontSize: "19px",
                            color: "#555",
                          }}
                        >
                          ({tamanho})
                        </span>
                      )}
                    </div>
                  </div>
                  <p className="descricao">{item.descricao}</p>
                  <div className="preco-estoque">
                    <span className="preco">R$ {preco}</span>
                    <span className="estoque">Estoque: {estoque}</span>
                  </div>
                  {/* Se existir variante, passa o tamanho como parâmetro */}
                  <Link
                    to={
                      item.variant
                        ? `/produtos/${item.id}?variant=${encodeURIComponent(
                            item.variant.tamanho
                          )}`
                        : `/produtos/${item.id}`
                    }
                    className="ver-mais-produto"
                  >
                    Ver Mais
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Produtos;
